import { CategoryGeneratorState } from '@quizzach/interfaces';

export function reorderData(data: CategoryGeneratorState[]) {
	function sortWithException(arr: any, exceptionName: any) {
		return arr.sort((a: any, b: any) => {
			if (a.name === exceptionName) return 1;
			if (b.name === exceptionName) return -1;
			return a.name.localeCompare(b.name);
		});
	}

	data = sortWithException(data, 'razno');

	data.forEach((category) => {
		if (category.subcategories) {
			category.subcategories = sortWithException(
				category.subcategories,
				'ostalo'
			);
		}
	});

	return data;
}
